<script lang="ts">
  import * as Sidebar from "$lib/components/ui/sidebar/index.js";
  import { activePageId, pages, type PageId } from "@/stores/selected-sidemenu-store.ts";

  const setPage = (pageId: PageId) => () => activePageId.set(pageId);
</script>

<Sidebar.Content>
  <Sidebar.Group>
    <Sidebar.GroupLabel>Menu</Sidebar.GroupLabel>
    <Sidebar.Menu>
      <Sidebar.MenuItem>
        {#each pages as page (page.id)}
          <Sidebar.MenuButton isActive={$activePageId === page.id} onclick={setPage(page.id)}>
            {#if page.icon}
              <svelte:component this={page.icon} />
            {/if}
            <span>{page.label}</span>
          </Sidebar.MenuButton>
        {/each}
      </Sidebar.MenuItem>
    </Sidebar.Menu>
  </Sidebar.Group>
</Sidebar.Content>


